<template>
  <div
    id="cross-cell-popup"
    :class="{ 'show-popup': showCrossCellPopup }"
    class="mobile-wrapper"
  >
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title d-flex align-items-center" @click="closePopup">
            <span class="material-icons md-36">keyboard_arrow_left</span>
            <span class="title-text">
              {{ $t("message.complete-your-order") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="popular-products">
      <div
        class="popular-product"
        v-for="product in popularProductsExcludeCartItems"
        :key="product.ID"
      >
        <popluartItem
          :product="menu.Products[product.ProductID]"
          :modifiers="menu.ModifierGroups"
          :category="product"
          :key="product.ID"
          @showAddToCart="productToShow = $event"
        />
      </div>
    </div>
    <div class="dismiss-container p-10">
      <button
        type="button"
        @click.prevent="closePopup()"
        class="btn btn-primary btn-lg btn-block"
        :style="mobileStyles.btn"
      >
        {{ $t("message.no-thanks") }}
      </button>
    </div>
    
    <AddToCart
      v-if="!!productToShow"
      :price="productToShow.Price"
      :category="productToShow"
      :product="menu.Products[productToShow.ProductID]"
      :modifiers="menu.ModifierGroups"
      :parentCategory="getCategory"
    />
  </div>
</template>
<script>
import popluartItem from "../products/popularProduct.vue";
import AddToCart from "../products/AddToCartMobile.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "CrossCell",
  components: {
    popluartItem,
    AddToCart,
  },
  props: {
    showCrossCell: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCrossCellPopup: false,
      productToShow: null,
    };
  },
  watch: {
    showCrossCell() {
      this.openPopup()
    }
  },
  computed: {
    ...mapGetters(["getPapularProducts", "storeMenu", "cartItems", "mobileStyles", "getCrossCellViewed", "getMenuId"]),
    popularProductsExcludeCartItems() {
      const popluartProducts = [];
      this.getPapularProducts.forEach((p) => {
        if (!this.cartItems.find((c) => c.id === p.ProductID)) {
          popluartProducts.push(p);
        }
      });
      return popluartProducts.slice(0, 3);
    },
    getCategory() {
      let parentCategory;
      this.menu.Categories.forEach((c) => {
        if (
          c.SubMenuItems.find(
            (p) => p.ProductID === this.productToShow.ProductID
          )
        ) {
          parentCategory = JSON.parse(JSON.stringify(c));
        }
      });
      return parentCategory;
    },
    menu: function () {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
  },
  methods: {
    ...mapMutations(["setCrossCellPopupViewStatus"]),
    openPopup() {
      if(this.popularProductsExcludeCartItems.length === 0) {
        this.closePopup();
      } else {
        this.showCrossCellPopup = true;
        document.body.style.overflow = "hidden";
      }
    },
    closePopup() {
      this.showCrossCellPopup = false;
      document.body.style.overflow = "";
      document.querySelector("#cross-cell-popup").style.top =
        document.body.scrollHeight + "px";
          this.$parent.navigateToCheckout();
      this.setCrossCellPopupViewStatus({menuId: this.getMenuId, isViewed: true});
    },
    closeModal() {
      this.closePopup();
    },
  },
};
</script>
<style scoped lang="scss">
.mobile-wrapper {
  position: fixed;
  top: 100%;
  height: 100vh;
  width: 100%;
  z-index: 1049;
  transition: all 0.5s;
  &.show-popup {
    top: 0;
  }
  .fixed-banner {
    position: relative !important;
  }
  .dismiss-container {
    position: absolute;
    width: 100%;
    border-top: 1px solid #80808038;
    padding: 20px;
    bottom: 0;
    background: white;
  }
  .popular-products {
    display: flex;
    flex-direction: column;
    height: calc(100% - 133px);
    .popular-product {
      flex-grow: 1;
      max-height: 50%;
    }
  }
}
</style>